import { TextField, IconButton, FormControl, Box, Typography, Button } from '@mui/material';
import { AddCircleOutline, HighlightOff } from '@mui/icons-material';
import CircularProgress from '@mui/material/CircularProgress';
import ReactMarkdown from 'react-markdown';
import mdComponents from './mdComponents';

const ReviewTips = ({ tips, setTips, onProofread, proofreadingIndex }) => (
  <fieldset>
    <legend>Tips</legend>
    {tips.map((tip, index) => (
      <Box key={index} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start', mb: 1 }}>
        <FormControl sx={{mb: 1}} fullWidth variant="outlined">
          <TextField
            label="Title"
            size="small"
            required
            value={tip.title}
            onChange={(e) => {
              const newTips = [...tips];
              newTips[index].title = e.target.value;
              setTips(newTips);
            }}
          />
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <TextField
            label="Description"
            multiline
            size="small"
            required
            rows={4}
            value={tip.description}
            onChange={(e) => {
              const newTips = [...tips];
              newTips[index].description = e.target.value;
              setTips(newTips);
            }}
          />
        </FormControl>
        <Box display="flex" alignItems="center" gap={1} mt={0.5}>
          <Button
            size="small"
            variant="outlined"
            onClick={() => onProofread(index)}
            disabled={proofreadingIndex !== null}
            startIcon={proofreadingIndex === index ? <CircularProgress size={14} color="inherit" /> : null}
          >
            {proofreadingIndex === index ? 'Proofreading...' : 'Proofread'}
          </Button>
          <IconButton onClick={() => {
            const newTips = [...tips];
            newTips.splice(index, 1);
            setTips(newTips);
          }}>
            <HighlightOff />
          </IconButton>
        </Box>
        <Typography variant="body1">
          <ReactMarkdown components={mdComponents}>{tip.description}</ReactMarkdown>
        </Typography>
      </Box>
    ))}
    <IconButton onClick={() => setTips([...tips, { title: '', description: '' }])}>
      <AddCircleOutline />
    </IconButton>
  </fieldset>
);

export default ReviewTips;
